import { TextField, Typography } from '@mui/material';

import DOMPurify from 'dompurify';

import { Loader } from 'common/components/Loader/Loader';

import styles from './SummaryDetails.module.scss';

interface ISummaryDetailsProps {
	summaryText: string;
	isEditable: boolean;
	isLoading: boolean;
	udpateSummaryHandler: any;
}

const SummaryDetails = ({
	summaryText,
	isEditable,
	isLoading,
	udpateSummaryHandler,
}: ISummaryDetailsProps) => {
	const onChangeValue = (event: any) => {
		udpateSummaryHandler(event.target.value);
	};
	return (
		<div>
			{isLoading ? (
				<Loader show={isLoading} />
			) : (
				<div>
					{!isEditable ? (
						<Typography className={styles['summary-display-text']}>
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(
										summaryText.replace(/\n/g, '<br />'),
									),
								}}
							/>
						</Typography>
					) : (
						<TextField
							fullWidth
							value={summaryText}
							inputProps={{ 'data-testid': 'editted-summary' }}
							type="text"
							onChange={(e) => onChangeValue(e)}
							className={styles['summary-display-text']}
							multiline
							rows={3}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default SummaryDetails;
